import { Grid } from "@mui/material";
import PoruwaLogo from "../../../../../images/column-end-placeholder2.png";

const FormHeader = () => {
  return (
    <Grid
      container
      direction="column"
      className="form-header"
      justifyContent="center"
      alignItems="center"
    >
      <img src={PoruwaLogo} alt="poruwa-logo" />
    </Grid>
  );
};

export default FormHeader;
